<template>
  <page-outline :title="$t('Webheader.rtp_network')">
    <template slot="pageContent">
      <f7-list class="mb-2">
        <f7-list-item>
          <div class="row d-flex">
            <div class="mx-3">
              <b-button class="btn btnFilter"
                :aria-label="$t('common.rfrsh')"
                @click="applyFilter()">
                <i class="fa-light fa-rotate-right"></i>
              </b-button>
            </div>
          </div>
        </f7-list-item>
      </f7-list>
      <spinner v-if="activateSpinner"></spinner>
      <b-table hover v-else-if="networkList.length > 0"
      class="table table-striped"
      :fields="fields"
      :items="networkList"
      :selectable="networkList.length > 0"
      empty-text="Pas de résultat"
      @row-selected="seeNetworkDetails">
      </b-table>
      <div v-else class="d-flex justify-content-center">
        <span class="noResult">
          {{ $t('common.no_result') }}
        </span>
      </div>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'RTPNetworkList',
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  data () {
    return {
      activateSpinner: false,
      networkList: []
    }
  },
  computed: {
    fields () {
      let fields = [
        { key: 'name', label: this.$i18n.t('administration.name'), class: 'text-center', sortable: true }
      ]
      return fields
    }
  },
  created () {
    this.applyFilter()
  },
  methods: {
    addCountry () {
      let that = this
      loadPage(that, {url: '/country/form/-1'})
    },
    applyFilter () {
      let that = this
      this.activateSpinner = true
      this.$engine.routing.network.fetch()
      .then(resp => {
        that.networkList = resp.data.networks
        that.activateSpinner = false
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    seeNetworkDetails (items) {
      let that = this
      console.log('items', items)
      this.$engine.routing.network.networkDetails = items[0]
      loadPage(that, {url: '/routing/network/form/' + items[0].id})
    }
  }
}

</script>

<style>
</style>
